// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9abee767e2c3c3b02024","678":"796d8c717d614899c335","883":"d7b5917589805f90f89f"}[chunkId] + ".js";
};